var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"footer":_vm.footer},scopedSlots:_vm._u([{key:"DETAILS",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Details',{attrs:{"row":params}}):_vm._e()]}},{key:"Email",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('EmailDetails',{attrs:{"send":_vm.sendEmail,"row":params}}):_vm._e()]}},{key:"WriteOffSlot",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('WriteOffOptimization',{attrs:{"params":params,"close":close}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }